import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../helpers/reselectHelpers';
import {startedEditingWorkspacesAction} from '../../../store/panels/inboxes/inboxesPanelActions';
import {WorkspaceCustomViewItem} from './workspaceCustomViewItem';
import {WorkspaceItemContainerProps, workspaceItemMapStateToProps} from './workspaceItemContainerHelpers';

const mapDispatchToProps = makeMapDispatchToProps<WorkspaceItemContainerProps>()(({panelId}) => ({
  editWorkspaces: (hasRarelyViewedItems: boolean) =>
    startedEditingWorkspacesAction(panelId, hasRarelyViewedItems),
}));

export const WorkspaceCustomViewItemContainer = connect(
  workspaceItemMapStateToProps,
  mapDispatchToProps,
  (stateProps, dispatchProps, ownProps) => {
    const onEditWorkspaces = () => {
      dispatchProps.editWorkspaces(stateProps.hasRarelyViewedItems);
    };
    return {
      ...stateProps,
      ...ownProps,
      onEditWorkspaces,
    };
  },
)(WorkspaceCustomViewItem);
